import {Address} from "../../address/model/Address";
import "./address-prompt.component.scss";
import {ToastNotificationService} from "../../utils/ToastNotificationService";
import {ToastNotificationServiceName} from "../../utils/names/serviceNames";
import {IScope} from "angular";

export class LetterAddress {
    to: Address;
    from: Address;
}

export class AddressPromptDialog implements ng.IComponentController {

    public static instance = (letterAddress: LetterAddress, customerName: string) => ({
        template: require('./address-prompt.component.html'),
        controller: [
            '$scope',
            '$http',
            '$q',
            '$mdDialog',
            ToastNotificationServiceName,
            'letterAddress',
            'customerName',
            AddressPromptDialog
        ],
        clickOutsideToClose: true,
        multiple: true,
        controllerAs: '$ctrl',
        bindings: {
            customerName: '<',
            letterAddress: '='
        },
        locals: {
            letterAddress,
            customerName
        }
    });

    private showLoading: boolean = false;

    constructor(private $scope: IScope,
                private $http: ng.IHttpService,
                private $q: ng.IQService,
                private $mdDialog: angular.material.IDialogService,
                private tostNotificationService: ToastNotificationService,
                private letterAddress: LetterAddress,
                private customerName: string) {
    }

    public submitCustomerAddress = (verifiedAddress: Address) => {
        this.letterAddress.to = verifiedAddress;

        if (this.letterAddress.from.verification.valid && this.letterAddress.to.verification.valid) {
            this.$mdDialog.hide(this.letterAddress);
        } else {
            this.$mdDialog.cancel()
        }

    };

    public closeModal = () => {
        this.$mdDialog.cancel();
    };
}